import {usePathname} from "next/navigation";

/**
 * A hook which generates a link with a redirect to the current page.
 *
 * Useful in cases where we want to send the user to e.g. select a campus, then come back to the current page.
 *
 * @param href - The href to redirect to
 * @returns The redirect URL
 */
export const useRedirectToCurrentPage = (href: string) => {
	const pathname = usePathname();
	return `${href}?redirect=${pathname}`;
};
